// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outro{font-family:LaPrairie;position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:space-between;align-items:center;padding:4.5rem 4.25rem}@media screen and (max-width:1023px){.outro{padding:2.75rem 1rem}}", ""]);
// Exports
module.exports = exports;
